import { Injectable } from '@angular/core';
import { FuseAlertAppearance, FuseAlertService, FuseAlertType } from '../../@fuse/components/alert';
import { ToastrService } from 'ngx-toastr';
import moment from 'moment/moment';

@Injectable({
  providedIn: 'root',
})
export class GlobalService {
  topMsg = {
    appearance: 'outline' as FuseAlertAppearance,
    dismissible: true,
    dismissed: true,
    name: 'top',
    type: 'error' as FuseAlertType,
    body: '',
    title: '',
    timeOut: 5000,
  };

  constructor(
    private FuseAlert: FuseAlertService,
    private toaster: ToastrService,
  ) {}

  handleErrors(error: any) {
    error.error.errors.forEach((errorMessage: string) => {
      this.toaster.error(errorMessage);
    });
  }

  showTopMsg(type: FuseAlertType, message: string, title: string = ''): void {
    this.topMsg.type = type;
    this.topMsg.body = message;
    this.topMsg.title = title;

    const typesMap = {
      primary: 'info',
      accent: 'info',
      warn: 'warning',
      basic: 'info',
      info: 'info',
      success: 'success',
      warning: 'warning',
      error: 'error',
    };
    this.toaster[typesMap[type]](message, title, null, 'success');
    /* this.FuseAlert.show('top');
     if (this.topMsg.timeOut !== 0) {

         setTimeout(() => {
             this.FuseAlert.dismiss('top');
         }, 5000);
     }*/
  }

  hideTopMsg(): void {
    this.topMsg.body = '';
    this.topMsg.title = '';
  }

  correctingTimeZone(date: any) {
    // console.log(date);
    let userInput = moment(date).toDate();

    // const targetTimeZone = 'Asia/Riyadh'; // target time zone
    // const originalTimeZone = moment.tz.guess(); // Get the current time zone of the browser
    //
    // // Convert the date to the target timezone
    // let userDateInTargetTimeZone = moment
    //   .tz(userInput, originalTimeZone)
    //   .tz(targetTimeZone);
    //
    // let dateTimeValue = userDateInTargetTimeZone.format('YYYY-MM-DD HH:mm:ss');

    // Convert the formatted date and time back to a Date object
    let correctedDate = moment(userInput, 'YYYY-MM-DD HH:mm:ss').toDate();

    const year = correctedDate.getFullYear();
    const month = correctedDate.getMonth() + 1;
    const day = correctedDate.getDate();
    const hour = correctedDate.getHours();
    const minutes = correctedDate.getMinutes();
    const seconds = correctedDate.getSeconds();
    return (date = year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds);
  }

  isNotificationsSupported(): boolean {
    return 'Notification' in window && 'serviceWorker' in navigator && 'PushManager' in window;
  }
}
